import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import EnterpriseClient from './component/enterprise-client';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <EnterpriseClient />
  </BrowserRouter>
);
